import axios from 'axios';
import useCurrentUser from '../hooks/useCurrentUser';
import { API_HOST } from '../constants/constants';

export const getCustomQuestions = async (currentTabId) => {
  const { token, userID } = useCurrentUser();
  let apiURL = `${API_HOST}/users/${currentTabId}/questions`;
  if (!currentTabId) {
    apiURL = `${API_HOST}/users/${userID}/questions`;
  }
  try {
    const response = await axios.get(apiURL, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        'x-dqpn-user-id': userID,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching custom questions:', error);
    return null;
  }
};
